import type { DemoScript } from "../types";
import { PERFORMANCE_SCRIPT_COPY } from "./performance-script.copy";

export const buildPerformanceScript = (): DemoScript => [
  {
    id: "perf-intro",
    narrative: PERFORMANCE_SCRIPT_COPY.perfIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "perf-month",
    narrative: PERFORMANCE_SCRIPT_COPY.perfMonth.narrative,
    zoomTargetId: "perf-month-selector",
    callout: {
      targetId: "perf-month-selector",
      text: PERFORMANCE_SCRIPT_COPY.perfMonth.callout,
    },
    durationMs: 4800,
  },
  {
    id: "perf-social",
    narrative: PERFORMANCE_SCRIPT_COPY.perfSocial.narrative,
    zoomTargetId: "perf-social-cards",
    callout: {
      targetId: "perf-social-cards",
      text: PERFORMANCE_SCRIPT_COPY.perfSocial.callout,
    },
    durationMs: 5400,
  },
  {
    id: "perf-overview",
    narrative: PERFORMANCE_SCRIPT_COPY.perfOverview.narrative,
    durationMs: 1800,
  },
  {
    id: "perf-aggregated",
    narrative: PERFORMANCE_SCRIPT_COPY.perfAggregated.narrative,
    zoomTargetId: "perf-aggregated",
    callout: {
      targetId: "perf-aggregated",
      text: PERFORMANCE_SCRIPT_COPY.perfAggregated.callout,
    },
    durationMs: 5200,
  },
  {
    id: "perf-charts",
    narrative: PERFORMANCE_SCRIPT_COPY.perfCharts.narrative,
    zoomTargetId: "perf-charts",
    zoomScale: 1.12,
    callout: {
      targetId: "perf-charts",
      text: PERFORMANCE_SCRIPT_COPY.perfCharts.callout,
    },
    durationMs: 5600,
  },
];
